import { render, staticRenderFns } from "./LoginSafe.vue?vue&type=template&id=5b8dd190&scoped=true&"
import script from "./LoginSafe.vue?vue&type=script&lang=js&"
export * from "./LoginSafe.vue?vue&type=script&lang=js&"
import style0 from "./LoginSafe.vue?vue&type=style&index=0&id=5b8dd190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8dd190",
  null
  
)

export default component.exports